import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";

import { A11y, Navigation } from "swiper/modules";

import $ from "jquery";
import Swiper from "swiper";

const swiperCarousel = (el) => {
    const $el = $(el);
    const swiperContainer = $el.find(".swiper")[0];
    const nextEl = $el.find(".swiper-button-next")[0];
    const prevEl = $el.find(".swiper-button-prev")[0];

    const swiper = new Swiper(swiperContainer, {
        direction: "horizontal",
        modules: [Navigation],
        speed: 700,
        spaceBetween: 16,
        effect: "fade",
        centeredInsufficientSlides: false,
        slidesPerView: "auto",
        loop: false,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
    });

    const updateButtonState = (swiperInstance) => {
        $(prevEl).attr("disabled", swiperInstance.isBeginning);
        $(prevEl).attr("aria-disabled", swiperInstance.isBeginning);

        $(nextEl).attr("disabled", swiperInstance.isEnd);
        $(nextEl).attr("aria-disabled", swiperInstance.isEnd);
    }

    swiper.on("transitionEnd", () => updateButtonState(swiper));

};
export default swiperCarousel;
